import { render, staticRenderFns } from "./learningMotivation.vue?vue&type=template&id=53d128fe"
import script from "./learningMotivation.vue?vue&type=script&lang=js"
export * from "./learningMotivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports